/**
 * 用户操作中心
 *
 * @file index.js
 * @author yangwei(yangwei14@baidu.com)
 */
import './i18n';
import {router} from 'san-router';
import './pages';
import './index.less';


(async function () {
    if (!router.isStarted) {
        router.start();
    }
})();
